import React, { useState, useMemo, useEffect } from "react";
import EmbedUploader from "components/Reusable/JUMBOform/EmbedUploader/EmbedUploader.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import EmbedFormTemplateBody from "./EmbedFormTemplateBody.js";
import EmbedFormTemplateFooter from "./EmbedFormTemplateFooter.js";
import EmbedFormTemplateFaileds from "./EmbedFormTemplateFaileds.js";
import Image from "components/Elements/Image/Image.tsx";
import { checkIfColorIsDark } from "../Helpers/ValidationFunctions.js";
import AnvilableFormComponent from "./AnvilableFormComponent/index.jsx";
import { normalizeDomain } from "../Helpers/normalizeDomain.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { EmbedFormMissingTid } from "../EmbedFormMissingTid/EmbedFormMissingTid.tsx";

const EmbedFormTemplateContainer = ({
  activeForm,
  allowUseForm,
  notExistForm,
  isPreview,
  direction,
  formInEmbedPage,
  width,
  height,
  formDetails,
  loading,
  displayPreview,
  startUpload,
  buttonBackgroundColor,
  setStartUpload,
  embedMailId,
  setEmbedMailId,
  finishUpload,
  setFinishUpload,
  handleFinishUploadProcess,
  backgroundFormColor,
  hideFooter,
  tidParam,
  hideDetails,
  includeTitleAndDesc,
  displayImageForm,
  formImage,
  displayTitleForm,
  formTitle,
  displayDescriptionForm,
  formDescription,
  embedJson,
  errorFields,
  setEmbedJson,
  prevCookies,
  createEmbedMail,
  buttonTextColor,
  loadingButton,
  searchParams,
  displayFooterLinks,
  linkFooters,
  allowUseFormText,
  loadingCulture,
  isDemoEmbedPage,
  typeUser,
  embedPageEditMode,
  maxFormHeight,
  innerScrollHeight,
  setReSendMail,
  skipForm,
}) => {
  const { getLanguage } = useContent();
  const { mobileCondition } = useMediaQueries();
  const [notActiveState, setNotActiveState] = useState(false);

  const [canShowForm, setCanShowForm] = useState(false);
  const [isDomainCheckError, setIsDomainCheckError] = useState(false);
  const [isTidMissing, setIsTidMissing] = useState(false);

  // Checks if the tid param is missing in the search params
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    setIsTidMissing(urlParams.get("skipForm") === "1" && !urlParams.get("tid"));
  }, [window.location]);

  // If the form is not displayed on domains, show the form
  useEffect(() => {
    if (formDetails && !formDetails.DisplayOnlyOnDomains) {
      setCanShowForm(true);
    }
  }, [formDetails]);

  // If the form is displayed on domains, check the domain
  useEffect(() => {
    if (!formDetails?.DisplayOnlyOnDomains) return;

    window.parent.postMessage({ type: "JM_EMBED_DOMAIN_CHECK" }, "*");

    const handleMessage = (event) => {
      if (
        !event.data ||
        typeof event.data !== "object" ||
        event.data.type !== "JM_EMBED_DOMAIN_CHECK_RESPONSE" ||
        !event.data.domain
      ) {
        return;
      }

      const normalizedParentDomain = normalizeDomain(event.data.domain);
      const allowedDomains = (formDetails?.ListedDomains || []).map(
        normalizeDomain
      );

      if (allowedDomains.includes(normalizedParentDomain)) {
        setCanShowForm(true);
        setIsDomainCheckError(false);
      } else {
        setCanShowForm(false);
        setIsDomainCheckError(true);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [formDetails?.DisplayOnlyOnDomains, formDetails?.ListedDomains]);

  useMemo(() => {
    if (!activeForm || !allowUseForm || notExistForm) {
      setNotActiveState(true);
    } else {
      setNotActiveState(false);
    }
  }, [activeForm, allowUseForm, notExistForm]);
  //check if is inside iframe and if yes, check the height of the iframe
  const isInsideIframe = window.self !== window.top;
  const iframeHeight = window.innerHeight;

  // Prevent direct link access to /form/ route
  const isDirectFormUrl = window.location.pathname.includes(
    `/${getLanguage()}/form/`
  );

  const isPreventedDisplayForm = isDirectFormUrl && !isInsideIframe;

  return (
    <div
      className={`embed-dynamic-template ${
        notActiveState && !isPreview ? "not-active-form" : ""
      } ${direction === "rtl" ? "right-to-left" : "left-to-right"} ${
        startUpload && isInsideIframe ? "uploader-mode-container" : ""
      }`}
      style={{
        width: !mobileCondition && !formInEmbedPage ? width : "unset",
      }}
    >
      {isTidMissing ? (
        <EmbedFormMissingTid />
      ) : (
        <>
          {formDetails &&
            !notActiveState &&
            displayPreview &&
            (canShowForm && !isDomainCheckError && !isPreventedDisplayForm ? (
              <div
                className={`embed-dynamic-container ${
                  checkIfColorIsDark(backgroundFormColor)
                    ? "dark-background"
                    : ""
                }`}
                style={{
                  backgroundColor: backgroundFormColor,
                }}
              >
                {startUpload || skipForm ? (
                  <EmbedUploader
                    backgroundColor={backgroundFormColor}
                    buttonsColor={buttonBackgroundColor}
                    setStartUpload={setStartUpload}
                    formDetails={formDetails}
                    embedMailId={embedMailId}
                    setEmbedMailId={setEmbedMailId}
                    finishUpload={finishUpload}
                    setFinishUpload={setFinishUpload}
                    handleFinishUploadProcess={handleFinishUploadProcess}
                    hideFooter={hideFooter}
                    tidParam={tidParam}
                    isInsideIframe={isInsideIframe}
                    setReSendMail={setReSendMail}
                  />
                ) : (
                  <>
                    <EmbedFormTemplateBody
                      typeUser={typeUser}
                      formDetails={formDetails}
                      hideDetails={hideDetails}
                      includeTitleAndDesc={includeTitleAndDesc}
                      displayImageForm={displayImageForm}
                      formImage={formImage}
                      displayTitleForm={displayTitleForm}
                      formTitle={formTitle}
                      displayDescriptionForm={displayDescriptionForm}
                      formDescription={formDescription}
                      embedJson={embedJson}
                      direction={direction}
                      errorFields={errorFields}
                      setEmbedJson={setEmbedJson}
                      buttonBackgroundColor={buttonBackgroundColor}
                      prevCookies={prevCookies}
                      createEmbedMail={createEmbedMail}
                      buttonTextColor={buttonTextColor}
                      loadingButton={loadingButton}
                      searchParams={searchParams}
                      isDemoEmbedPage={isDemoEmbedPage}
                      isPreview={isPreview}
                      embedPageEditMode={embedPageEditMode}
                      formInEmbedPage={formInEmbedPage}
                      maxFormHeight={maxFormHeight}
                      innerScrollHeight={innerScrollHeight}
                      displayFooterLinks={displayFooterLinks}
                      isInsideIframe={isInsideIframe}
                      iframeHeight={iframeHeight}
                    />
                    {displayFooterLinks && (
                      <EmbedFormTemplateFooter linkFooters={linkFooters} />
                    )}
                  </>
                )}
              </div>
            ) : (
              <AnvilableFormComponent
                isPreventedDisplayForm={isPreventedDisplayForm}
              />
            ))}
          {notActiveState && (
            <EmbedFormTemplateFaileds
              allowUseForm={allowUseForm}
              loading={loading}
              isPreview={isPreview}
              allowUseFormText={allowUseFormText}
              activeForm={activeForm}
              notExistForm={notExistForm}
            />
          )}
          {loading || loadingCulture ? (
            <div
              className="loading-container-form"
              style={{
                height: `${isInsideIframe ? iframeHeight : height}px`,
                width: `${width}px`,
              }}
            >
              <Image alt="" title="" name="preloader" ext="gif" />
            </div>
          ) : null}
        </>
      )}
    </div>
  );
};

export default EmbedFormTemplateContainer;
